import React from 'react';
import { isNull } from 'lodash-es';
import columns, { ColumnType } from './PastBookingColumns';
import * as tablesUtils from 'utils/tablesUtils';
import { hasFlight } from 'utils/flightsUtils';
import { PastBookingsData } from 'AppClient/api/Bookings';
import styles from './styles.module.scss';
import { DownloadButton, ExternalLink, TooltipCell } from 'components';
import { Button, Rate } from 'components/antd';

interface PastBookingsColumnsProps {
	onRating: (bookingId: number) => void;
	onBookAgain: (bookingId: number) => void;
}

const getServicePartnerPhone = (value: string) => {
	return <ExternalLink href={`tel:${value}`} text={value} />;
};

const getAddressOrFlight = (index?: number) => {
	return (text: string, record: PastBookingsData) => {
		const { bookingAddresses } = record;
		const lastIndex = bookingAddresses.length - 1;
		const addr = bookingAddresses[index !== undefined ? index : lastIndex];
		if (hasFlight(addr)) {
			return `${addr.flight.flightNumber}, ${addr.flight.airportAddress}`;
		}
		return text;
	};
};

const getTravelSummary = (_: string, record: PastBookingsData) => {
	const {
		isGenerationInProgress,
		generationError,
		bookingId,
		bookingNumber,
		isBillable,
	} = record;
	if (!isGenerationInProgress && isNull(generationError) && isBillable) {
		return (
			<DownloadButton
				type="TR"
				invoiceBookingId={bookingId}
				invoiceBookingNumber={bookingNumber}
				showName
			/>
		);
	}
	return null;
};

const getBookAgain = (
	_value: string,
	record: PastBookingsData,
	props: PastBookingsColumnsProps
) => {
	return (
		<>
			<Button size="small" onClick={() => props.onBookAgain(record.bookingId)}>
				Book again
			</Button>
			<TooltipCell
				tooltipTitle="Cancelled booking"
				placement="bottom"
				showTooltip={record.isBookingCancelled}
				linePosition="right"
				lineType="alert"
				className={styles.tooltip}
			/>
		</>
	);
};

const getRating = (_value: string, record: PastBookingsData, props: PastBookingsColumnsProps) => {
	const { rating } = record;

	if (rating) {
		return <Rate disabled value={rating} />;
	}

	return (
		<Button type="primary" size="small" onClick={() => props.onRating(record.bookingId)}>
			Leave feedback
		</Button>
	);
};

const columnComponents = {
	[ColumnType.PICK_UP_ADDRESS]: getAddressOrFlight(0),
	[ColumnType.DROP_OFF_ADDRESS]: getAddressOrFlight(),
	[ColumnType.SERVICE_PARTNER_PHONE]: getServicePartnerPhone,
	[ColumnType.TRAVEL_SUMMARY]: getTravelSummary,
	[ColumnType.RATING]: getRating,
	[ColumnType.BOOK_AGAIN]: getBookAgain,
};

export default tablesUtils.getColumnsWithRender<PastBookingsColumnsProps>(
	columns,
	columnComponents
);
